export default __webpack_public_path__ + "static/cafe_36040-29be3dbcfcd9f9415a02bc78bcaed4ee.png";